var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.currentCohort.es_cohortid + 'grades-page',staticClass:"grades-component"},[_c('grades-name'),_c('grades-percentages'),_c('grades-chart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }